import { createTheme as createMuiTheme, type Theme, type PaletteMode } from '@mui/material'
import { breakpoints } from './breakpoints.js'
import { createComponents, shape } from './components.js'
import { createPalette } from './palette.js'
import { createTypography } from './typography.js'
import { type DhlThemeOptions } from './types.js'

export const createTheme = (mode: PaletteMode, { device, ...rest }: DhlThemeOptions): Theme => {
  const palette = createPalette(mode)
  // The optionable responsive typography is done only for the new theme from `@dhl-ui`
  // do not set this here to false!
  const typography = createTypography(palette, true)
  const components = createComponents(palette, true, typography, rest)

  return createMuiTheme({
    breakpoints,
    components,
    palette,
    shape,
    typography,
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
    device,
  })
}

/**
 * Temporary solution to merge two themes untill we are finished migrating
 */
export const rawThemeCurrent = (
  mode: PaletteMode,
  // reason: we can use any newly created @dhl-ui/components option but do not want to depend on this library overhere :)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { device, ...rest }: DhlThemeOptions & Record<string, any>
  // reason: we will be mixing two Theme defined themes which are not the same!
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
  const palette = createPalette(mode)
  // we set the base-unit ourselves and do not need responsive breakpoints on typography being used
  const typography = createTypography(palette, true)
  const components = createComponents(palette, false, typography, rest)

  return {
    breakpoints,
    components,
    palette,
    shape,
    typography,
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
    device,
  }
}
